document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('StoryGrid');
  const paths = document.getElementById('StoryPaths');

  if (!grid) return;

  const chapters = Array.from(grid.querySelectorAll('.js-story-reveal'));

  // ---------- Pfad-Filter ----------
  if (paths) {
    const buttons = Array.from(paths.querySelectorAll('[data-story-path]'));

    function applyFilter(path) {
      chapters.forEach((chapter) => {
        chapter.classList.toggle('is-filtered-out', chapter.dataset.storyGroup !== path);
      });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        applyFilter(button.dataset.storyPath);
      });
    });

    // Feste Standardgroesse: Grid-Hoehe der groessten Kategorie ermitteln
    // und als Mindesthoehe setzen, damit die Seite beim Kategoriewechsel
    // nicht springt - das rotierende Wappen (mittig in der Section) bleibt
    // dadurch immer an derselben Stelle, egal welche Kategorie ausgewaehlt ist.
    if (buttons.length) {
      let maxHeight = 0;
      buttons.forEach((button) => {
        applyFilter(button.dataset.storyPath);
        maxHeight = Math.max(maxHeight, grid.scrollHeight);
      });
      grid.style.minHeight = `${maxHeight}px`;

      buttons[0].classList.add('is-active');
      applyFilter(buttons[0].dataset.storyPath);
    }
  }

  // ---------- Scroll-Reveal ----------
  // Karten sind per CSS-Default sichtbar (falls dieses Script nicht laedt).
  // Nur wenn IntersectionObserver verfuegbar ist, blenden wir sie kurz aus
  // und lassen sie beim Reinscrollen wieder einfliegen.
  if ('IntersectionObserver' in window) {
    chapters.forEach((chapter) => chapter.classList.add('js-story-pending'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('js-story-pending');
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    chapters.forEach((chapter) => observer.observe(chapter));
  }
});
